import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { DrawerProvider } from './Drawer2.js';
import { ToastProvider } from './Toast2.js';
import { InternalNinjaThemeContextProvider } from './ThemeProvider2.js';

const NinjaThemeProvider = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (jsx(InternalNinjaThemeContextProvider, { value: props, children: jsx(ToastProvider, { children: jsx(DrawerProvider, { children: children }) }) }));
};

export { NinjaThemeProvider };
